import { Component, inject } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { LayoutComponent } from "./layout/layout.component";
import { CommonModule } from "@angular/common";

@Component({
	selector: "app-root",
	imports: [LayoutComponent, RouterOutlet, CommonModule],
	templateUrl: "./app.component.html",
	styleUrl: "./app.component.scss",
})
export class AppComponent {
	private router = inject(Router);
	title = "zanga-member-frontend";

	shouldShowLayout(): boolean {
		const currentUrl = this.router.url;
		// Don't show layout for login and auth pages
		return !currentUrl.includes("/login") && !currentUrl.includes("/auth/");
	}
}
